(function () {
  var scope = document.getElementById('hb-cart-scope');
  if (!scope) return;

  var sectionId = scope.getAttribute('data-section-id');
  var announcer = document.getElementById('hb-cart-announcer');
  var pendingTimers = {};

  // Guards against out-of-order responses: if the user fires several
  // mutations in quick succession (e.g. removing multiple lines), an
  // earlier request's response can arrive after a later one and clobber
  // the page with stale data. Each refresh captures the version counter
  // at request time and only applies its result if it's still the latest.
  var requestVersion = 0;

  function announce(text) {
    if (!announcer) return;
    announcer.textContent = '';
    window.setTimeout(function () {
      announcer.textContent = text;
    }, 50);
  }

  function setBusy(isBusy) {
    scope.classList.toggle('hb-cart-scope--busy', isBusy);
  }

  function refreshSection() {
    if (!sectionId) return Promise.resolve();
    var myVersion = ++requestVersion;
    var url = window.location.pathname + '?sections=' + encodeURIComponent(sectionId);
    return fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (myVersion !== requestVersion) return;
        var html = data[sectionId];
        if (!html) return;
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var fresh = doc.getElementById('hb-cart-scope');
        if (fresh) {
          scope.replaceWith(fresh);
          scope = fresh;
          sectionId = scope.getAttribute('data-section-id');
          announcer = document.getElementById('hb-cart-announcer');
        }
      });
  }

  function afterMutation(message) {
    document.dispatchEvent(new CustomEvent('cart:updated'));
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    return refreshSection().then(function () {
      setBusy(false);
      if (message) announce(message);
    });
  }

  function changeLine(key, quantity, label) {
    setBusy(true);
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart change failed');
        return res.json();
      })
      .then(function () {
        var message = quantity === 0
          ? (label ? label + ' ' + ((window.hbStrings || {}).removedSuffix || 'poistettu ostoskorista') : ((window.hbStrings || {}).itemRemoved || 'Tuote poistettu ostoskorista'))
          : (label ? label + ', ' + ((window.hbStrings || {}).quantityLower || 'määrä') + ' ' + quantity : ((window.hbStrings || {}).quantityUpdated || 'Määrä päivitetty'));
        return afterMutation(message);
      })
      .catch(function () {
        return refreshSection().then(function () {
          setBusy(false);
          announce(((window.hbStrings || {}).updateFailed || 'Ostoskorin päivitys epäonnistui. Yritä uudelleen.'));
        });
      });
  }

  function addVariant(variantId, label) {
    setBusy(true);
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart add failed');
        return res.json();
      })
      .then(function () {
        return afterMutation(label ? label + ' ' + ((window.hbStrings || {}).addedSuffix || 'lisätty ostoskoriin') : ((window.hbStrings || {}).itemAdded || 'Tuote lisätty ostoskoriin'));
      })
      .catch(function () {
        setBusy(false);
        announce(((window.hbStrings || {}).addFailed || 'Tuotteen lisääminen epäonnistui. Yritä uudelleen.'));
      });
  }

  function scheduleChange(key, quantity, label) {
    if (pendingTimers[key]) window.clearTimeout(pendingTimers[key]);
    pendingTimers[key] = window.setTimeout(function () {
      delete pendingTimers[key];
      changeLine(key, quantity, label);
    }, 300);
  }

  document.addEventListener('click', function (e) {
    var stepBtn = e.target.closest('[data-hb-cart-step]');
    if (stepBtn) {
      var itemEl = stepBtn.closest('[data-hb-cart-item]');
      if (!itemEl) return;
      var qtyEl = itemEl.querySelector('[data-hb-cart-qty]');
      var titleEl = itemEl.querySelector('.hb-cart-item__title');
      var current = parseInt(qtyEl.textContent, 10) || 0;
      var delta = parseInt(stepBtn.getAttribute('data-hb-cart-step'), 10);
      var next = Math.max(0, current + delta);
      qtyEl.textContent = next;
      scheduleChange(itemEl.getAttribute('data-key'), next, titleEl ? titleEl.textContent : '');
      return;
    }

    var removeBtn = e.target.closest('[data-hb-cart-remove]');
    if (removeBtn) {
      var removeItemEl = removeBtn.closest('[data-hb-cart-item]');
      if (!removeItemEl) return;
      var removeTitleEl = removeItemEl.querySelector('.hb-cart-item__title');
      removeItemEl.style.opacity = '0.4';
      changeLine(removeItemEl.getAttribute('data-key'), 0, removeTitleEl ? removeTitleEl.textContent : '');
      return;
    }

    var addBtn = e.target.closest('[data-hb-cross-add]');
    if (addBtn) {
      var crossItemEl = addBtn.closest('[data-hb-cross-item]');
      var crossTitleEl = crossItemEl ? crossItemEl.querySelector('.hb-cart-cross-item__title') : null;
      var variantId = addBtn.getAttribute('data-variant-id');
      if (!variantId) return;
      addBtn.disabled = true;
      addVariant(variantId, crossTitleEl ? crossTitleEl.textContent : '').then(function () {
        addBtn.disabled = false;
      });
      return;
    }

    var discountBtn = e.target.closest('#hb-cart-discount-btn');
    if (discountBtn) {
      var input = document.getElementById('hb-cart-discount-input');
      var code = input ? input.value.trim() : '';
      window.location.href = code ? '/checkout?discount=' + encodeURIComponent(code) : '/checkout';
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    if (e.target && e.target.id === 'hb-cart-discount-input') {
      e.preventDefault();
      var btn = document.getElementById('hb-cart-discount-btn');
      if (btn) btn.click();
    }
  });
})();